import { render, staticRenderFns } from "./popupBg.vue?vue&type=template&id=2c767a23&scoped=true"
import script from "./popupBg.vue?vue&type=script&lang=js"
export * from "./popupBg.vue?vue&type=script&lang=js"
import style0 from "./popupBg.vue?vue&type=style&index=0&id=2c767a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c767a23",
  null
  
)

export default component.exports